export const RATINGEN_MEASURES = [
	"BHKW_Gesamtbezug_ABB_Wirk_Plus_1_Energie",
	"BHKW_Gesamteinspeisung_ABB_Wirk_Minus_2_Energie",
	"BHKW_Generator1_71282_Energie",
	"BHKW_Generator2_71284_Energie",
	"Verwaltungsgebaude_UG_Station4_PV_1951063_Energie",
	"Wasser_Hauptzugang_G69927_2100001_13_Wasser_Durchflussmenge",
	"Normvolumen_Gas_7_732_96_05_18_Durchflussmenge",
	"Empfang_PV_Anlage_UV_rechts_oben_1395203",
];
